import { render, staticRenderFns } from "./qualityBox.vue?vue&type=template&id=fa891e74&scoped=true&"
import script from "./qualityBox.vue?vue&type=script&lang=js&"
export * from "./qualityBox.vue?vue&type=script&lang=js&"
import style0 from "./qualityBox.vue?vue&type=style&index=0&id=fa891e74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa891e74",
  null
  
)

export default component.exports